import React from "react";
import Grid from "@material-ui/core/Grid";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Item from "./Item";
import i18n from "../../../i18nextInitiator";
import {connect} from "react-redux";
import {formatTime} from "../../../actions/actionCreators";

/**
 * This is the funciton to access translations.
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa','general');
/**
 * the function the use styles with JSS.
 * @type {(props?: any) => ClassNameMap<"address"|"title">}
 */
const useStyles = makeStyles((theme) => ({
    box: {
        '& *': {
            margin: ".15rem 0"
        },
    }
}))
/**
 * Redux States.
 * @param state
 */
const mapStateToProps = state => ({ ...state.invoice });
/**
 * This component represents every single item of shipping details. Addresses and time.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ShippingDetails = props => {
    const classes = useStyles();
    const items = [
        {title: t('location.origin'),
            text: props.bill ? props.bill.origin_address : undefined
        },
        {title: t('location.destination'),
            text: props.bill ? props.bill.destination_address : undefined
        },
        {title: t('time.time'),
            text: props.bill ?  formatTime(props.bill.time)
                : undefined
        },
    ];
    const Content = () => {
        return items.map((item, index) => {
            return <Item key={index} title={item.title} text={item.text}/>
        })
    }
    return(
        <Grid container className={classes.box}>
            <Content/>
        </Grid>
    );
};
export default connect(mapStateToProps)(ShippingDetails);